export default (tabbarId) => {
    const optionsTabbar = $$(tabbarId).data.options;
    optionsTabbar.forEach((option) => {
        $$(tabbarId).enableOption(option.id);
    });
};
